import { useCallback } from 'react';

import { AuthService, AuthTokenService, UsersService } from 'src/services';

import { useSignUpContext } from '../context';
import { SignUpError } from '../context/types';
import { RegisterDto } from 'src/models/Auth';
import { useSearchParams } from 'react-router-dom-v5-compat';

export const useSignUp = () => {
  const [{
    coupon,
    couponCode,
    product,
    userDetails,
    consents,
    validUserDetailsProvided,
  }, dispatchSignUpAction] = useSignUpContext();
  const [ searchParams, ] = useSearchParams();
  const affiliateId = searchParams.get('a_aid') ?? undefined;

  return useCallback(async () => {
    if (!product) {
      dispatchSignUpAction({ type: 'setError', error: SignUpError.UnknownError });
      return;
    }

    dispatchSignUpAction({ type: 'signUpStarted' });
    if (!validUserDetailsProvided || !consents.termsAndConditions) {
      return;
    }

    const registerDto: RegisterDto = {
      name: [userDetails.firstName, userDetails.lastName].join(' ').trim(),
      email: userDetails.email,
      password: userDetails.password,
      subscriptionProductId: product.id,
      couponCode,
      promoCode: coupon?.promoCode,
      termsAndConditionsConsent: consents.termsAndConditions,
      marketingConsent: consents.marketing,
      profilingConsent: consents.profiling,
      affiliateId,
    };

    try {
      const registerRes = await AuthService.registerV2(registerDto);
      AuthTokenService.set(registerRes.accessToken);
      // The GTM purchase event fires from PaymentComplete once Stripe confirms
      // the payment (there's no transaction yet at this point, only redirect).
      const { url } = await UsersService.checkoutSession(product.id, {
        couponCode,
        promoCode: coupon?.promoCode,
        affiliateId,
      });
      window.location.href = url;
    } catch (error: any) {
      dispatchSignUpAction({ type: 'signUpError', error });
    }
  }, [
    coupon,
    couponCode,
    userDetails,
    product,
    consents,
    dispatchSignUpAction,
    validUserDetailsProvided,
    affiliateId,
  ]);
};
